/* @flow */
import React from 'react'
import ArticleImageBox from './Articles/StyledArticleImageBox'
import ArticleList from './Articles/StyledArticleList'
import ArticleListBox from './Articles/StyledArticleListBox'
import WidgetContainer from '../containers/WidgetContainer'
import { getRedirectOptions } from '../utils/Admon'
import { ImageRow, RegularCol, RegularRow } from '../utils/Grid'
import UTM from '../utils/UTM'
import LinkHandler from '../utils/LinkHandler'
import { EXCHANGE_BASE_URL, EXCHANGE_IMAGES_PATH } from '../../constants'
import { type FinanceWidgetProps } from './Types'

declare var UNVERSIONED_STATICS_PATH: string

export default (props: FinanceWidgetProps) => {
  const {
    activeDynamicLayout,
    isOpening,
    widget,
    widget: {
      boxes,
      imageCount,
      imageSize = '4_3',
      meta: {
        admon
      } = {},
      utmContent,
      utmMedium,
      utmSource
    }
  } = props

  if (!boxes.length) {
    return null
  }

  const textBoxes = [...boxes]
  const headBoxes = textBoxes.splice(0, imageCount)

  return (
    <WidgetContainer widget={widget} isOpening={isOpening}>
      {
        headBoxes.length > 0 &&
        <ImageRow>
          {
            headBoxes.map(box => {
              const {
                featuredType,
                go,
                guid,
                images,
                link,
                source,
                title
              } = box

              if (source.indexOf('ExchangeArticles') > -1) {
                const image = `${UNVERSIONED_STATICS_PATH}${EXCHANGE_IMAGES_PATH.ARTICLES}${images[imageSize]}`

                const redirectOptions = getRedirectOptions(admon, activeDynamicLayout)

                const sasLink = new LinkHandler(`${EXCHANGE_BASE_URL}?go=${go}`).applySASRedirect(redirectOptions).link

                return (
                  <RegularCol key={guid}>
                    <ArticleImageBox
                      featuredType={featuredType}
                      image={image}
                      imageClass={`image-${imageSize}`}
                      isImage={true}
                      link={sasLink}
                      title={title}
                    />
                  </RegularCol>
                )
              } else {
                const imagePath = images[imageSize]
                const image = imagePath.indexOf('http://') === -1 && imagePath.indexOf('https://') === -1
                  ? `${UNVERSIONED_STATICS_PATH}${images[imageSize]}`
                  : images[imageSize]

                const utmLink = new UTM(link).getUTMLink({
                  utmContent,
                  utmMedium,
                  utmSource,
                  utmTerm: `position-${boxes.indexOf(box)}`,
                  utmCampaign: source
                })

                return (
                  <RegularCol key={guid}>
                    <ArticleImageBox
                      featuredType={featuredType}
                      image={image}
                      imageClass={`image-${imageSize}`}
                      isImage={true}
                      link={utmLink}
                      title={title}
                    />
                  </RegularCol>
                )
              }
            })
          }
        </ImageRow>
      }
      {
        textBoxes.length > 0 &&
        <RegularRow>
          <RegularCol>
            <ArticleList>
              {
                textBoxes.map(box => {
                  const {
                    featuredType,
                    guid,
                    link,
                    source,
                    title
                  } = box

                  const utmLink = new UTM(link).getUTMLink({
                    utmContent,
                    utmMedium,
                    utmSource,
                    utmTerm: `position-${boxes.indexOf(box)}`,
                    utmCampaign: source
                  })

                  return (
                    <ArticleListBox
                      featuredSize='inline'
                      featuredType={featuredType}
                      key={guid}
                      link={utmLink}
                      title={title}
                    />
                  )
                })
              }
            </ArticleList>
          </RegularCol>
        </RegularRow>
      }
    </WidgetContainer>
  )
}
